// Role → capability matrix. The web app uses it to show or hide actions, the
// API enforces it on every route, and the database repeats the same rules as
// row-level security policies (apps/api/drizzle/*_security.sql).
import type { Role } from "./types";

export const PERMISSIONS = {
  /** Read a company's dashboard. The chamber admin reads every company. */
  viewCompany: ["chamber_admin", "company_admin", "operator"],
  /** Create and edit clients and operations. */
  capture: ["company_admin", "operator"],
  /** Delete clients and operations. */
  delete: ["company_admin"],
  /** Risk levels, notices, zero reports, dismissing alerts. */
  manageCompliance: ["company_admin"],
  /** Company data and the UMA value. */
  configure: ["company_admin"],
  /** Invite team members and cancel pending invitations. */
  manageTeam: ["company_admin"],
  /** List the team and turn a member's access off or back on. The chamber admin may do it in any company. */
  manageAccess: ["chamber_admin", "company_admin"],
  viewAuditLog: ["chamber_admin", "company_admin"],
  /** List every company with its alert counts. */
  chamberPanel: ["chamber_admin"],
} as const satisfies Record<string, readonly Role[]>;

export type Permission = keyof typeof PERMISSIONS;

export const can = (role: Role, permission: Permission): boolean =>
  (PERMISSIONS[permission] as readonly Role[]).includes(role);
